import React, { PureComponent } from "react";
import styled from "styled-components";
import Icon from "@fortawesome/react-fontawesome";
import { cookieListener, socialCookiesEnabled } from "../../cookieListener";
import config from "../../config";
import { colors } from "../../theme";

const ShareContainer = styled.div`
  margin: ${props => (props.small ? "0px" : "50px 0px")};
  display: flex;
`;

const ShareButton = styled.a`
  display: ${props => (props.small ? "flex" : "inline-block")};
  margin-right: 10px;
  text-decoration: none;
  color: white;
  padding: 5px;
  @media (min-width: 575px) {
    padding: 10px;
  }
  font-weight: bold;
  border-radius: ${props => (props.small ? "30px" : "2px")};
  background-color: ${colors.blue};
  align-items: center;
  justify-content: space-around;
`;

const FacebookShareButton = styled(ShareButton)`
  background-color: #3b5998;
  opacity: ${props => (props.disabled ? 0.2 : 1)};
`;

const TwitterShareButton = styled(ShareButton)`
  background-color: #1dcaff;
  opacity: ${props => (props.disabled ? 0.2 : 1)};
`;

const ShareIcon = styled(Icon)`
  margin-right: 10px;
`;

class ShareButtons extends PureComponent {
  state = {
    socialCookiesEnabled: socialCookiesEnabled()
  };

  shareFacebook(e) {
    const { mode } = this.props;

    e.preventDefault();

    if (mode === "city") {
      this.fbShareCity();
    } else if (mode === "party") {
      this.fbShareParty();
    }
  }

  shareTwitter(e) {
    const { city, party, mode } = this.props;

    e.preventDefault();
    let text, url;

    if (mode === "city") {
      text = `Ontdek de kieskaart van ${city.name}`;
      url = `${config.FRONTEND_URL}/gemeente/${city.slug}`;
    } else if (party) {
      text = `Ontdek de kieskaart van ${party.name} uit ${city.name}`;
      url = `${config.FRONTEND_URL}/gemeente/${city.slug}/${party.slug}`;
    }

    window.open(
      `https://twitter.com/intent/tweet?text=${encodeURIComponent(
        text
      )}&url=${encodeURIComponent(url)}&via=MNMbe`,
      "tweet",
      "width=400,height=300"
    );
  }

  fbShareCity() {
    const { city } = this.props;
    this.doFBShare({
      "og:url": `${config.FRONTEND_URL}/gemeente/${city.slug}`,
      "og:title": `Check de emoji’s van ${city.name} op de MNM Kieskaart.`,
      "og:description": `Ontdek hier hoe de politieke partijen in ${
        city.name
      } het verschil willen maken!`,
      "og:image": city.screenshotUrl
        ? city.screenshotUrl
        : `${config.FRONTEND_URL}/share.png`,
      "og:image:width": "1200",
      "og:image:height": "630"
    });
  }

  fbShareParty() {
    const { party, city } = this.props;
    this.doFBShare({
      "og:url": `${config.FRONTEND_URL}/gemeente/${city.slug}/${party.slug}`,
      "og:title": `Check de emoji’s van ${party.name} ${
        city.name
      } op de MNM Kieskaart.`,
      "og:description": `Ontdek hier hoe wij met ${party.name} in ${
        city.name
      } het verschil willen maken!`,
      "og:image": party.screenshotUrl
        ? party.screenshotUrl
        : `${config.FRONTEND_URL}/share.png`,
      "og:image:width": "1200",
      "og:image:height": "630"
    });
  }

  showConsent() {
    if (window.VRT && window.VRT.cookieConsent) {
      window.VRT.cookieConsent.showConsent();
      new cookieListener("cookie_settings__social", status => {
        if (status === cookieListener.prototype.UPDATED) {
          this.setState({ socialCookiesEnabled: socialCookiesEnabled() });
        }
      });
    }
  }

  doFBShare(object) {
    window.FB.ui(
      {
        method: "share_open_graph",
        action_type: "og.likes",
        action_properties: JSON.stringify({
          object
        })
      },
      function(response) {}
    );
  }

  render() {
    const { small } = this.props;
    const { socialCookiesEnabled } = this.state;
    if (!socialCookiesEnabled) {
      return (
        <ShareContainer small={small}>
          <FacebookShareButton
            href="#"
            onClick={e => {
              e.preventDefault();
              this.showConsent();
            }}
            small={small}
            disabled={true}
            title="Pas je cookies aan om dit te delen"
          >
            <ShareIcon
              icon={["fab", "facebook"]}
              style={{ marginRight: small ? "auto" : "10px" }}
            />
            {small ? null : <span>Pas je cookies aan om dit te delen</span>}
          </FacebookShareButton>
          <TwitterShareButton
            href="#"
            disabled={true}
            onClick={e => {
              e.preventDefault();
              this.showConsent();
            }}
            small={small}
            title="Pas je cookies aan om dit te delen"
          >
            <ShareIcon
              icon={["fab", "twitter"]}
              style={{ marginRight: small ? "auto" : "10px" }}
            />
            {small ? null : <span>Pas je cookies aan om dit te delen</span>}
          </TwitterShareButton>
        </ShareContainer>
      );
    } else {
      return (
        <ShareContainer small={small}>
          <FacebookShareButton
            href="#"
            onClick={e => {
              this.shareFacebook(e);
            }}
            small={small}
          >
            <ShareIcon
              icon={["fab", "facebook"]}
              style={{ marginRight: small ? "auto" : "10px" }}
            />
            {small ? null : <span>Deel op Facebook</span>}
          </FacebookShareButton>

          <TwitterShareButton
            href="#"
            small={small}
            onClick={e => {
              this.shareTwitter(e);
            }}
          >
            <ShareIcon
              icon={["fab", "twitter"]}
              style={{ marginRight: small ? "auto" : "10px" }}
            />
            {small ? null : <span>Deel op Twitter</span>}
          </TwitterShareButton>
        </ShareContainer>
      );
    }
  }
}

export default ShareButtons;



// WEBPACK FOOTER //
// ./src/components/ShareButtons/index.js